/*
 * Create the store with asynchronously loaded reducers
 */

import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { save, load } from "redux-localstorage-simple"
import createRootReducer from './reducers';
import rootSaga from './sagas';

// we use redux-sagas to work with asynchronous actions
const sagaMiddleware = createSagaMiddleware();
const devtools = window.devToolsExtension || (() => noop => noop);


// export function to configure our redux store with middleware
export default function configureStore() {
  // Combine our middlewares here
  // 1. sagaMiddleware: Makes redux-sagas work
  const middlewares = [
    sagaMiddleware,
    save({states: ['loginState'], namespace: 'AppAuthData', debounce: 1000})
  ];

  
  // collect all of the store enhancers we'll be using
  const enhancers = [
    applyMiddleware(...middlewares),
    devtools(),
  ];

  const store = createStore(
    createRootReducer(),
    load({states: ['loginState'], namespace: 'AppAuthData', disableWarnings: true}),
    compose(...enhancers),
  );

  // start running all sagas composed in the rootSaga
  sagaMiddleware.run(rootSaga);

  return store;
}

export const store = configureStore();
